import React from 'react'
import { useIntl } from 'react-intl'
import { Modal, ModalHead, ModalBody } from 'mailup-web-components'
import { WarningMessage } from './components'
import PropTypes from 'prop-types'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'
import { Foot } from './components/Foot'

import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  contentScheduledState,
  isValidDateState,
  setBoxErrorState
} from 'Components/ContentScheduled/recoil/state'
import { verifyDateCallback } from 'Components/ContentScheduled/recoil/callbacks'

const ModalSchedule = ({
  pecPlusStatus,
  show,
  dismiss,
  confirm,
  idSending,
  scheduleDate,
  timeZoneCode,
  error,
  severity,
  sending
}) => {
  const intl = useIntl()

  const { momentUtcDate, momentTimeZoneDate, timeZone } = useRecoilValue(
    contentScheduledState
  )
  const verifyDate = useRecoilCallback(verifyDateCallback, [])
  const setBoxError = useSetRecoilState(setBoxErrorState)
  const isValidDate = useRecoilValue(isValidDateState)

  return (
    <Modal
      className='b-modal-schedule'
      show={show}
      onClose={dismiss}
      closeOnOverlayClick
      data-mu-test='modal-delete-schedule'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Schedulation.setScheduleTitle'
        })}
      >
        <WarningMessage
          idSending={idSending}
          error={error}
          severity={severity}
          pecPlusStatus={pecPlusStatus}
        />
      </ModalHead>
      <ModalBody>
        <ContentScheduled
          scheduleDate={scheduleDate}
          scheduleTimeZoneCode={timeZoneCode}
        />
      </ModalBody>
      <Foot
        disabled={!isValidDate}
        onClickCancel={dismiss}
        onClickConfirm={async () => {
          const { valid } = await verifyDate(momentTimeZoneDate)
          if (valid) {
            confirm(idSending, momentUtcDate, timeZone)
          } else {
            setBoxError(true)
          }
        }}
        sending={sending}
      />
    </Modal>
  )
}

ModalSchedule.defaultProps = {
  sending: false
}

ModalSchedule.propTypes = {
  pecPlusStatus: PropTypes.string,
  show: PropTypes.bool,
  dismiss: PropTypes.func,
  confirm: PropTypes.func,
  idSending: PropTypes.any, // num/str
  scheduleDate: PropTypes.any,
  timeZoneCode: PropTypes.any,
  error: PropTypes.string,
  severity: PropTypes.string,
  sending: PropTypes.bool
}

export default ModalSchedule
